import { Helmet } from "react-helmet-async";
import { useEffect } from "react";

const SEO = ({ 
  title = "Home", 
  description = "A-rated double glazing, uPVC windows, composite doors & garden rooms in Lanarkshire, Motherwell, Hamilton & Glasgow. Free quotes. 10 year guarantee. Call 07917 181597", 
  keywords = "",
  canonical 
}) => {
  const baseUrl = "https://www.cglanceydoubleglazing.co.uk";
  const fullTitle = String(title || "Home") + " | C. Glancey Double Glazing";
  const pageUrl = canonical ? baseUrl + canonical : baseUrl;
  const desc = String(description || "");
  
  // Directly update meta tags since react-helmet-async v2 meta prop doesn't work
  useEffect(() => {
    // Update or create meta description
    let metaDescEl = document.querySelector('meta[name="description"]');
    if (!metaDescEl) {
      metaDescEl = document.createElement('meta');
      metaDescEl.setAttribute('name', 'description');
      document.head.appendChild(metaDescEl);
    }
    metaDescEl.setAttribute('content', desc);

    // Update or create meta keywords
    if (keywords) {
      let metaKw = document.querySelector('meta[name="keywords"]');
      if (!metaKw) {
        metaKw = document.createElement('meta');
        metaKw.setAttribute('name', 'keywords');
        document.head.appendChild(metaKw);
      }
      metaKw.setAttribute('content', keywords);
    }

    // Update OG tags
    const ogTags = {
      'og:title': fullTitle,
      'og:description': desc,
      'og:url': pageUrl,
      'og:type': 'website',
      'og:site_name': 'C. Glancey Double Glazing',
      'og:locale': 'en_GB',
    };
    Object.entries(ogTags).forEach(([prop, content]) => {
      let tag = document.querySelector(`meta[property="${prop}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', prop);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });

    // Update twitter tags
    const twitterTags = {
      'twitter:card': 'summary_large_image',
      'twitter:title': fullTitle,
      'twitter:description': desc,
    };
    Object.entries(twitterTags).forEach(([name, content]) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });

    // Update canonical
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('href', pageUrl);
    } else if (canonicalLink) {
      canonicalLink.remove();
    }
  }, [desc, keywords, fullTitle, pageUrl, canonical]);
  
  return (
    <Helmet
      title={fullTitle}
      meta={[
        { name: "robots", content: "index, follow" },
        { name: "author", content: "C. Glancey Double Glazing" },
        { name: "geo.region", content: "GB-SCT" },
        { name: "geo.placename", content: "Lanarkshire, Scotland" },
      ]}
    />
  );
};

// Common location keywords for reuse
export const LOCATION_KEYWORDS = "Motherwell, Bellshill, Hamilton, Wishaw, Glasgow, Lanarkshire, East Kilbride, Newton Mearns, Blantyre, Coatbridge, Airdrie, Uddingston, Rutherglen, Cambuslang, Bothwell, Larkhall, Carluke, Shotts, Cumbernauld, Bishopbriggs, Kirkintilloch, Paisley, Renfrewshire, South Lanarkshire, North Lanarkshire";

export default SEO;
